module.exports = __webpack_public_path__ + "img/contact-cropped-map.6c5d3cc6.png";